import React from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import { localeShortDateTime } from "../../../../app/datetimeUtils";
import { scoreReportEssayLink } from "../../../../app/links";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import { formatNumber, formatNumberOneDecimal } from "../../shared/reportUtil";
import { CrTraitScoreViewModel, CrTraitScoreWithNormsViewModel } from "./performanceReportApiSlice";

export function CrTraitScoreTable(props: {
	className: string;
	scores: CrTraitScoreWithNormsViewModel[];
	averages: CrTraitScoreViewModel;
}) {
	const hasData = props.scores && props.scores.length > 0;

	const dateTimeTemplate = (rowData: CrTraitScoreWithNormsViewModel) => {
		return (
			<Link className="link" to={scoreReportEssayLink(rowData.essayId)}>
				{localeShortDateTime(rowData.date)}
			</Link>
		);
	};

	const totalScoreTemplate = (rowData: CrTraitScoreWithNormsViewModel) => {
		return formatNumber(rowData.totalScore);
	};

	const textualEvidenceTemplate = (rowData: CrTraitScoreWithNormsViewModel) => {
		return formatNumber(rowData.textualEvidenceScore);
	};

	const contentAccuracyTemplate = (rowData: CrTraitScoreWithNormsViewModel) => {
		return formatNumber(rowData.contentAccuracyScore);
	};

	const footerGroup = (
		<ColumnGroup>
			<Row>
				<Column
					footer="Overall Average"
					footerClassName="font-medium !text-right"
					colSpan={3}
				/>
				<Column
					footer={formatNumberOneDecimal(props.averages.totalScore)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.averages.textualEvidenceScore)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.averages.contentAccuracyScore)}
					footerClassName="font-medium"
				/>
			</Row>
		</ColumnGroup>
	);

	return (
		<DataTable
			value={props.scores}
			dataKey="essayId"
			loading={props.scores == undefined}
			emptyMessage="No results found"
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className}`}
			footerColumnGroup={hasData && footerGroup}>
			<Column header="Date" body={dateTimeTemplate} sortable sortField="date"></Column>
			<Column header="Prompt" field="promptName" sortable></Column>
			<Column header="Drafts" field="draftCount" sortable></Column>
			<Column header="Holistic/Total" body={totalScoreTemplate}></Column>
			<Column header="Textual Evidence" body={textualEvidenceTemplate}></Column>
			<Column header="Content Accuracy" body={contentAccuracyTemplate}></Column>
		</DataTable>
	);
}
